import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrQuestionComponent } from './pr-question/pr-question.component';
import { PrQuestionsComponent } from './pr-questions/pr-questions.component';

@NgModule({
  declarations: [PrQuestionComponent, PrQuestionsComponent],
  imports: [CommonModule],
  exports: [PrQuestionComponent, PrQuestionsComponent],
})
export class PrQuestionModule {}
